import Component from './lottery_page_lose.vue'
export default Component
